import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RegistrationTokenVerificationResponse } from 'signature-public-api-sdk';
import { SignUpState } from '€slices/sign-up/sign-up-types';
import { actions as authActions } from '€slices/auth';
import { RequestState } from '~/src/types/RequestState';

const initialState: SignUpState = {
    signingUp: false,
    signUpFailed: false,
    signUpSuccess: false,

    regTokenData: null,
    regTokenValidateState: RequestState.Idle,
};

const slice = createSlice({
    name: 'signUp',
    initialState: initialState as SignUpState,
    reducers: {
        validateRegToken: state => ({
            ...state,
            regTokenValidateState: RequestState.Loading,
        }),
        successValidateRegToken: (
            state,
            action: PayloadAction<RegistrationTokenVerificationResponse>,
        ) => ({
            ...state,
            regTokenValidateState: RequestState.Idle,
            regTokenData: action.payload,
        }),
        errorValidateRegToken: state => ({
            ...state,
            regTokenValidateState: RequestState.Error,
        }),
        requestSignUp: state => ({
            ...state,
            signingUp: true,
            signUpSuccess: false,
            signUpFailed: false,
            signUpError: undefined,
        }),
        receivedSignUpSuccess: state => ({
            ...state,
            signingUp: false,
            signUpSuccess: true,
            signUpFailed: false,
            signUpError: undefined,
            regTokenData: null,
        }),
        receivedSignUpError: (state, action: PayloadAction<string>) => ({
            ...state,
            signingUp: false,
            signUpSuccess: false,
            signUpFailed: true,
            signUpError: action.payload,
        }),
    },
    extraReducers: {
        [authActions.receiveLoginSuccess.type]: () => initialState,
    },
});

export default slice;
export const { actions, reducer } = slice;
